import { handleActions } from "redux-actions";

export default handleActions(
  {
    CONTACTS_PUBLIC_GET: {
      FULFILLED: (state, action) => ({
        contacts: action.payload.contacts,
      }),
    },
  },
  {},
  { namespace: "_" }
);
